// CUSTOM IFB — Guida alle taglie (snippets/ifb-size-guide.liquid)
// Calcolatore altezza/età → taglia, tabelle abbigliamento/scarpine e selezione della taglia nella scheda.

(() => {
  if (customElements.get('ifb-size-guide')) return;

  // Testi di riserva (italiano): quelli tradotti arrivano dallo snippet in <script type="application/json" data-ifb-i18n>
  // (chiavi ifb.size_guide.* dei file locales/). {n}, {from}, {to}, {size}, {label} sono segnaposto.
  const FALLBACK = {
    finder_clothes: 'Quanto è alto il tuo bimbo?',
    finder_shoes: 'Quanto è lungo il piedino?',
    input_clothes: 'Altezza in centimetri',
    input_shoes: 'Lunghezza del piede in centimetri',
    birth: 'Nascita',
    month: '{n} mese',
    months: '{n} mesi',
    year: '{n} anno',
    years: '{n} anni',
    range_month: '{from}–{to} mese',
    range_months: '{from}–{to} mesi',
    range_years: '{from}–{to} anni',
    th_size: 'Taglia',
    th_age: 'Età',
    th_height: 'Altezza',
    th_weight: 'Peso',
    th_shoe: 'Numero',
    th_foot: 'Piede',
    shoe_size: 'numero {size}',
    foot_up_to: 'piede fino a {size} cm',
    note_over: 'È oltre la nostra tabella: scrivici e ti aiutiamo a scegliere.',
    note_near: 'È vicino al limite: se vuoi che duri di più, prendi la taglia successiva ({label}).',
    note_age_shoes: "Per l'età è indicativo: misurare il piedino è più preciso.",
    note_age_clothes: "L'età è indicativa: con l'altezza il consiglio è più preciso.",
    select: 'Seleziona {size}',
    sold_out: '{size} esaurita',
    no_match: 'Questo capo non ha una taglia corrispondente, guarda la tabella qui sotto o scrivici.',
    recommend: 'Ti consigliamo',
    decimal: ',',
  };

  // Età come specifica, tradotta al momento: ['b'] nascita, ['m', n] mesi, ['y', n] anni,
  // ['mr', da, a] intervallo di mesi, ['yr', da, a] intervallo di anni.
  // Misure indicative standard europee (altezza in cm, peso in kg). "months" = età massima della taglia.
  const CLOTHES = [
    { label: ['b'], size: '0M', age: ['m', 0], months: 0, h: [44, 50], w: '2,5–3,5' },
    { label: ['m', 1], size: '1M', age: ['mr', 0, 1], months: 1, h: [50, 56], w: '3,5–4,5' },
    { label: ['m', 3], size: '3M', age: ['mr', 1, 3], months: 3, h: [56, 62], w: '4,5–6' },
    { label: ['m', 6], size: '6M', age: ['mr', 3, 6], months: 6, h: [62, 68], w: '6–8' },
    { label: ['m', 9], size: '9M', age: ['mr', 6, 9], months: 9, h: [68, 74], w: '8–9' },
    { label: ['m', 12], size: '12M', age: ['mr', 9, 12], months: 12, h: [74, 80], w: '9–10,5' },
    { label: ['m', 18], size: '18M', age: ['mr', 12, 18], months: 18, h: [80, 86], w: '10,5–12' },
    { label: ['m', 24], size: '24M · 2A', age: ['mr', 18, 24], months: 24, h: [86, 92], w: '12–13,5' },
    { label: ['y', 3], size: '36M · 3A', age: ['yr', 2, 3], months: 36, h: [92, 98], w: '13,5–15,5' },
    { label: ['y', 4], size: '4A', age: ['yr', 3, 4], months: 48, h: [98, 104], w: '15,5–17,5' },
    { label: ['y', 5], size: '5A', age: ['yr', 4, 5], months: 60, h: [104, 110], w: '17,5–19,5' },
    { label: ['y', 6], size: '6A', age: ['yr', 5, 6], months: 72, h: [110, 116], w: '19,5–21,5' },
  ];
  const SHOES = [
    { eu: 15, foot: 9.5, age: ['mr', 0, 3], months: 3 },
    { eu: 16, foot: 10.2, age: ['mr', 3, 6], months: 6 },
    { eu: 17, foot: 10.8, age: ['mr', 6, 9], months: 9 },
    { eu: 18, foot: 11.5, age: ['mr', 9, 12], months: 12 },
    { eu: 19, foot: 12.1, age: ['mr', 12, 15], months: 15 },
    { eu: 20, foot: 12.8, age: ['mr', 15, 18], months: 18 },
    { eu: 21, foot: 13.4, age: ['mr', 18, 24], months: 24 },
    { eu: 22, foot: 14.1, age: ['y', 2], months: 30 },
    { eu: 23, foot: 14.8, age: ['yr', 2, 3], months: 36 },
    { eu: 24, foot: 15.4, age: ['y', 3], months: 42 },
  ];
  const AGES = [
    [0, ['b']], [1, ['m', 1]], [3, ['m', 3]], [6, ['m', 6]], [9, ['m', 9]], [12, ['y', 1]],
    [18, ['m', 18]], [24, ['y', 2]], [36, ['y', 3]], [48, ['y', 4]], [60, ['y', 5]], [72, ['y', 6]],
  ];
  const GROWTH_ROOM = 0.7; // cm di spazio in più per il piedino

  // Valore di una taglia del prodotto → intervallo di mesi (o numero di scarpa). null se ambiguo.
  // Unità accettate anche nelle altre lingue del negozio (valori delle varianti tradotti).
  const MONTH_UNITS = 'm|mesi|mese|month|months|monat|monate|mois|mes|meses';
  const YEAR_UNITS = 'a|anni|anno|y|year|years|jahr|jahre|j|an|ans|año|años';
  function parseSize(raw) {
    const v = String(raw).trim().toLowerCase();
    let m;
    if ((m = v.match(new RegExp(`^(\\d+)\\s*(${MONTH_UNITS})$`)))) return { kind: 'months', from: +m[1], to: +m[1] };
    if ((m = v.match(new RegExp(`^(\\d+)\\s*(${YEAR_UNITS})$`)))) return { kind: 'months', from: +m[1] * 12, to: +m[1] * 12 };
    if ((m = v.match(new RegExp(`^(\\d+)\\s*[-/–]\\s*(\\d+)\\s*(${MONTH_UNITS})?$`)))) return { kind: 'range', from: +m[1], to: +m[2] };
    if ((m = v.match(/^(\d{2})$/)) && +m[1] >= 14 && +m[1] <= 30) return { kind: 'shoe', eu: +m[1] };
    return null;
  }

  // Il filtro | t di Shopify può restituire entità HTML (es. &#39;): le riconverto in testo
  function decode(str) {
    const el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  class IfbSizeGuide extends HTMLElement {
    // Testo tradotto con i segnaposto {nome} sostituiti
    t(key, vars = {}) {
      const str = this.strings[key] ?? FALLBACK[key] ?? key;
      return str.replace(/\{(\w+)\}/g, (all, name) => (name in vars ? vars[name] : all));
    }

    // Età da specifica (vedi CLOTHES) a testo nella lingua del negozio
    age([kind, a, b]) {
      if (kind === 'b') return this.t('birth');
      if (kind === 'm') return this.t(a === 1 ? 'month' : 'months', { n: a });
      if (kind === 'y') return this.t(a === 1 ? 'year' : 'years', { n: a });
      if (kind === 'mr') return this.t(b === 1 ? 'range_month' : 'range_months', { from: a, to: b });
      return this.t('range_years', { from: a, to: b });
    }

    // Numero decimale con il separatore della lingua (es. 10,5 / 10.5)
    num(value) {
      return String(value).replace(/[.,]/g, this.t('decimal'));
    }

    connectedCallback() {
      this.strings = {};
      try {
        const data = JSON.parse(this.querySelector('script[data-ifb-i18n]')?.textContent || '{}');
        Object.keys(data).forEach((k) => {
          if (typeof data[k] === 'string') this.strings[k] = decode(data[k]);
        });
      } catch (e) {
        // testi di riserva in italiano
      }
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('[data-sg-input]');
      this.mode = this.dataset.mode === 'shoes' ? 'shoes' : 'clothes';
      this.pick = null; // riga consigliata

      this.querySelector('[data-sg-open]').addEventListener('click', () => this.open());
      this.querySelector('[data-sg-close]').addEventListener('click', () => this.dialog.close());
      // Clic sullo sfondo scuro: chiude
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });
      this.querySelectorAll('[data-sg-tab]').forEach((b) =>
        b.addEventListener('click', () => this.setMode(b.dataset.sgTab))
      );
      this.querySelectorAll('[data-sg-step]').forEach((b) =>
        b.addEventListener('click', () => {
          const step = this.mode === 'shoes' ? 0.5 : 1;
          const start = this.mode === 'shoes' ? 11 : 62;
          const cur = parseFloat(this.input.value.replace(',', '.'));
          this.input.value = Number.isFinite(cur) ? Math.max(1, cur + step * +b.dataset.sgStep) : start;
          this.fromMeasure();
        })
      );
      this.input.addEventListener('input', () => this.fromMeasure());
      this.setMode(this.mode);
    }

    open() {
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
    }

    setMode(mode) {
      this.mode = mode;
      this.pick = null;
      this.input.value = '';
      this.querySelectorAll('[data-sg-tab]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.sgTab === mode)));
      this.querySelectorAll('[data-sg-how]').forEach((s) => (s.hidden = s.dataset.sgHow !== mode));
      const shoes = mode === 'shoes';
      this.querySelector('[data-sg-finder-title]').textContent = this.t(shoes ? 'finder_shoes' : 'finder_clothes');
      this.input.step = shoes ? '0.1' : '1';
      this.input.setAttribute('aria-label', this.t(shoes ? 'input_shoes' : 'input_clothes'));
      this.renderAges();
      this.renderTable();
      this.renderResult();
    }

    renderAges() {
      const box = this.querySelector('[data-sg-ages]');
      const list = this.mode === 'shoes' ? AGES.filter(([m]) => m >= 3 && m <= 36) : AGES;
      box.innerHTML = list.map(([m, l]) => `<button type="button" class="ifb-sg__chip" data-months="${m}">${this.age(l)}</button>`).join('');
      box.querySelectorAll('button').forEach((b) =>
        b.addEventListener('click', () => {
          this.input.value = '';
          this.fromAge(+b.dataset.months);
          box.querySelectorAll('button').forEach((x) => x.classList.toggle('is-active', x === b));
        })
      );
    }

    clearAgeChips() {
      this.querySelectorAll('.ifb-sg__chip').forEach((x) => x.classList.remove('is-active'));
    }

    fromMeasure() {
      this.clearAgeChips();
      const v = parseFloat(String(this.input.value).replace(',', '.'));
      if (!Number.isFinite(v) || v <= 0) {
        this.pick = null;
      } else if (this.mode === 'shoes') {
        const need = v + GROWTH_ROOM;
        const i = SHOES.findIndex((r) => r.foot >= need);
        this.pick = i === -1 ? { index: SHOES.length - 1, over: true } : { index: i, near: false };
      } else {
        const i = CLOTHES.findIndex((r) => v <= r.h[1]);
        if (i === -1) this.pick = { index: CLOTHES.length - 1, over: true };
        else this.pick = { index: i, near: v > CLOTHES[i].h[1] - 2 && i < CLOTHES.length - 1 };
      }
      this.renderTable();
      this.renderResult();
    }

    fromAge(months) {
      const rows = this.mode === 'shoes' ? SHOES : CLOTHES;
      const i = rows.findIndex((r) => r.months >= months);
      this.pick = { index: i === -1 ? rows.length - 1 : i, near: false, byAge: true };
      this.renderTable();
      this.renderResult();
    }

    renderTable() {
      const t = this.querySelector('[data-sg-table]');
      const sel = this.pick ? this.pick.index : -1;
      if (this.mode === 'shoes') {
        t.innerHTML = `<thead><tr><th scope="col">${this.t('th_shoe')}</th><th scope="col">${this.t('th_foot')}</th><th scope="col">${this.t('th_age')}</th></tr></thead><tbody>${SHOES.map(
          (r, i) => `<tr${i === sel ? ' class="is-pick"' : ''}><th scope="row">${r.eu}</th><td>${this.num(r.foot)} cm</td><td>${this.age(r.age)}</td></tr>`
        ).join('')}</tbody>`;
      } else {
        t.innerHTML = `<thead><tr><th scope="col">${this.t('th_size')}</th><th scope="col">${this.t('th_age')}</th><th scope="col">${this.t('th_height')}</th><th scope="col">${this.t('th_weight')}</th></tr></thead><tbody>${CLOTHES.map(
          (r, i) => `<tr${i === sel ? ' class="is-pick"' : ''}><th scope="row">${r.size}</th><td>${this.age(r.age)}</td><td>${r.h[0]}–${r.h[1]} cm</td><td>${this.num(r.w)} kg</td></tr>`
        ).join('')}</tbody>`;
      }
      const row = t.querySelector('.is-pick');
      if (row) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    // Radio delle taglie nella scheda prodotto
    sizeInputs() {
      const form = document.querySelector('variant-selects, variant-radios, .product-form__input')?.closest('section, .product') || document;
      return [...form.querySelectorAll('input[type="radio"]')].filter((i) => /^(taglia|size|misura|gr(ö|oe|o)(ß|ss)e|taille|talla)/i.test(i.name));
    }

    // Taglie del prodotto che corrispondono alla riga consigliata
    matches() {
      if (!this.pick) return [];
      const inputs = this.sizeInputs();
      if (this.mode === 'shoes') {
        const eu = SHOES[this.pick.index].eu;
        return inputs.filter((i) => parseSize(i.value)?.eu === eu);
      }
      const target = CLOTHES[this.pick.index].months;
      const parsed = inputs.map((i) => ({ i, s: parseSize(i.value) })).filter((x) => x.s && x.s.kind !== 'shoe');
      const ranges = parsed.filter((x) => x.s.kind === 'range' && x.s.from < Math.max(target, 0.5) && target <= x.s.to);
      if (ranges.length) return ranges.map((x) => x.i);
      // Taglia singola uguale o di poco più grande (mai un salto di anni rispetto al consiglio)
      const singles = parsed
        .filter((x) => x.s.kind === 'months' && x.s.to >= target && x.s.to - target <= Math.max(3, target / 2))
        .sort((a, b) => a.s.to - b.s.to);
      return singles.length ? singles.filter((x) => x.s.to === singles[0].s.to).map((x) => x.i) : [];
    }

    renderResult() {
      const box = this.querySelector('[data-sg-result]');
      if (!this.pick) {
        box.hidden = true;
        return;
      }
      const shoes = this.mode === 'shoes';
      const r = shoes ? SHOES[this.pick.index] : CLOTHES[this.pick.index];
      const name = shoes ? this.t('shoe_size', { size: r.eu }) : this.age(r.label);
      const detail = shoes
        ? `${this.t('foot_up_to', { size: this.num(r.foot) })} · ${this.age(r.age)}`
        : `${r.h[0]}–${r.h[1]} cm · ${this.num(r.w)} kg`;
      let note = '';
      if (this.pick.over) note = this.t('note_over');
      else if (this.pick.near) note = this.t('note_near', { label: this.age(CLOTHES[this.pick.index + 1].label) });
      else if (this.pick.byAge) note = this.t(shoes ? 'note_age_shoes' : 'note_age_clothes');

      const found = this.matches();
      let actions = '';
      if (found.length) {
        actions = `<div class="ifb-sg__pick">${found
          .map((i) => {
            const out = i.classList.contains('disabled');
            return `<button type="button" class="button ifb-sg__select" data-input="${i.id}"${out ? ' disabled' : ''}>${this.t(out ? 'sold_out' : 'select', { size: i.value })}</button>`;
          })
          .join('')}</div>`;
      } else if (this.sizeInputs().length) {
        actions = `<p class="ifb-sg__nomatch">${this.t('no_match')}</p>`;
      }

      box.innerHTML = `<p class="ifb-sg__result-label">${this.t('recommend')}</p>
        <p class="ifb-sg__result-size">${name}</p>
        <p class="ifb-sg__result-detail">${detail}</p>
        ${note ? `<p class="ifb-sg__result-note">${note}</p>` : ''}
        ${actions}`;
      box.hidden = false;
      box.querySelectorAll('[data-input]').forEach((b) =>
        b.addEventListener('click', () => {
          const input = document.getElementById(b.dataset.input);
          if (!input) return;
          input.click();
          this.dialog.close();
          input.closest('fieldset, .product-form__input')?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        })
      );
    }
  }

  customElements.define('ifb-size-guide', IfbSizeGuide);
})();
